<template>
  <div>
    <b-table :fields="fields" :items="data" :busy="isBusy">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Carregando...</strong>
        </div>
      </template>
      <template #cell(UpdateDate)="data">
        <span v-copy>{{ data.item.UpdateDate | datetime }}</span>
      </template>
      <template #cell()="data">
        <span v-copy>{{ data.value }}</span>
      </template>
    </b-table>
    <hr />
    <b-button class="float-right" variant="primary" @click="download"
      >Export</b-button
    >
    <b-modal
      id="modal-TableAudit-export"
      ref="modal-TableAudit-export"
      title="Exportar"
      size="xl"
      header-bg-variant="primary"
      header-text-variant="light"
      hide-footer
      scrollable
    >
      <ExportFile v-model="csvparam" />
    </b-modal>

    <!-- csvparam: {{ csvparam }} -->
  </div>
</template>

<script>
import API from "@/services/apiservices";
import ExportFile from "@/components/ExportFile.vue";
import { TableAuditModel } from "@/models/tableaudit";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TableAudit",

  components: {
    ExportFile,
  },

  props: {
    tb: {
      type: String,
      default: "",
    },
    pk: {
      type: String,
      default: "",
    },
    fieldname: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      csvparam: {
        fld: [],
        sep: ";",
        quoted: "",
        whead: true,
        filename: "data.dat",
        csvstream: "",
        data: [],
      },
      fields: [
        "Type",
        "FieldName",
        "OldValue",
        "NewValue",
        "UpdateDate",
        "UserName",
      ],
      data: [],
    };
  },

  computed: {
    ...mapGetters("auditStore", ["gtxAudit"]),
    params() {
      return {
        table: this.tb,
        PK: this.pk,
        FieldName: this.fieldname,
      };
    },
    isBusy() {
      return this.data.length == 0;
    },
  },

  beforeMount() {
    this.buscaLog();
  },

  methods: {
    ...mapActions("auditStore", ["actAuditDataGet"]),

    buscaLog() {
      this.data = [];
      if (this.tb !== "" && this.pk != "") {
        API.post("Servicos/HistoricoPadrao/Get", this.params).then((res) => {
          if (res.data.Success) {
            const data = API.prepareData(res.data);
            this.data = data.data;
            this.$emit("evtTableAuditGet", data.data);
          } else {
            this.$root.toastdanger(data.data.Error);
          }
        });
      } else {
        if (this.gtxAudit.table !== "" && this.gtxAudit.PK !== "") {
          this.actAuditDataGet()
            .then((data) => {
              // console.log("TableAudit::buscalog.data:", data);
              if (data.success) {
                this.data = data.data;
              } else {
                this.$root.toastdanger(data.error);
                // console.error(data.error);
              }
            })
            .catch((erro) => {
              this.$root.toastdanger(erro.error);
              // console.error(erro.error);
            });
        }
      }
    },
    download() {
      this.csvparam.filename = `audit_${this.tb}_${new Date()
        .toLocaleDateString()
        .replaceAll("/", "_")}`;
      this.csvparam.data = new TableAuditModel().fromArray(this.data);
      this.$refs["modal-TableAudit-export"].show();
    },
  },
};
</script>